import { Component, OnInit, OnDestroy } from '@angular/core';
import { SocketActions, SocketEvents } from '@app/modules/client/constant';
import { SocketService } from '@app/services/socket/socket.service';
import { ToastrService } from '@app/services/toastr/toastr.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications = [];
  showNotificationSidebar = false;
  notificationSubscription$: Subscription = new Subscription();

  constructor(
    private toastrService: ToastrService,
    private socketService: SocketService
  ) {}

  ngOnInit() {
    const notifications = localStorage.getItem('notifications');
    if (notifications) {
      this.notifications = JSON.parse(notifications);
    }

    this.getToastNotifications();
    this.getAsyncNotifications();
  }

  getToastNotifications() {
    this.notificationSubscription$.add(
      this.toastrService.notificationMessage$.subscribe((upcomingNotification: any) => {
        if (upcomingNotification?.msg?.length) {
          const notification = {
            status: upcomingNotification.status?.length ? upcomingNotification.status : 'info',
            date: upcomingNotification.date
              ? upcomingNotification.date
              : new Date().toLocaleString('en-US').replace(',', ''),
            msg: upcomingNotification.msg,
          };

          this.notifications.unshift(notification);
          localStorage.setItem('notifications', JSON.stringify(this.notifications));
        }
      })
    );
  }

  getAsyncNotifications() {
    this.notificationSubscription$.add(
      this.socketService.subscribeSocketEvent(SocketEvents.NOTIFICATIONS).subscribe((notification: any) => {
        if (notification?.event && notification.event === 'message' && notification?.data?.msg) {
          const notificationMessage = {
            status: notification.data.status?.length ? notification.data.status : 'info',
            date: notification.data.timestamp || new Date().toLocaleString('en-US').replace(',', ''),
            msg: notification.data.msg,
          };

          this.notifications.unshift(notificationMessage);
          localStorage.setItem('notifications', JSON.stringify(this.notifications));
        }
      })
    );
  }

  dismissNotification(index: number, event: any) {
    this.notifications.splice(index, 1);
    localStorage.setItem('notifications', JSON.stringify(this.notifications));
    if (this.notifications.length) event.stopPropagation();
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnDestroy() {
    if (this.notificationSubscription$) {
      this.notificationSubscription$.unsubscribe();
    }
  }
}
